import React, { PropsWithChildren } from "react";


interface ProfileTitleProps {
    className?: string;
}

const ProfileTitle = ({children, className}: PropsWithChildren<ProfileTitleProps>) => {
    return (
        <h4 className={`flex items-center h-14 justify-between text-lg leading-none font-extrabold text-shopfood-title ${className}`}>
            { children }
        </h4>
    );
};

export default ProfileTitle;